import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { PortfolioGallery } from "@/components/site/PortfolioGallery";
import { Services } from "@/components/site/Services";
import { BookingSystem } from "@/components/site/BookingSystem";
import { Footer } from "@/components/site/Footer";
import Admin from "@/components/Admin";

const Site = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const onNavigate = (id) => {
    if (id === "top") {
      lenisRef.current ? lenisRef.current.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    lenisRef.current ? lenisRef.current.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App grain">
      <Nav onNavigate={onNavigate} />
      <main>
        <Hero onNavigate={onNavigate} />
        <Manifesto />
        <EditorialMarquee />
        <PortfolioGallery />
        <Services />
        <BookingSystem />
      </main>
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </LanguageProvider>
  );
}

export default App;
